import { makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  // Outer height matches the Brand-80 paperclip circle so pill + attach read as one group.
  root: {
    display: 'flex',
    alignItems: 'center',
    height: tokens.spacingHorizontalXXL,
  },
  // Light brand surface behind paperclip + expand + count so they read as one control.
  // Hover/active live on this outer surface so the whole pill darkens uniformly
  // (not a nested Fluent Button hover rect inside the pill).
  pill: {
    backgroundColor: tokens.colorBrandBackground2,
    borderRadius: tokens.borderRadiusCircular,
    paddingRight: tokens.spacingHorizontalXS,
    ':hover': {
      backgroundColor: tokens.colorBrandBackground2Hover,
    },
    ':active': {
      backgroundColor: tokens.colorBrandBackground2Pressed,
    },
  },
  attachButton: {
    width: tokens.spacingHorizontalXXL,
    height: tokens.spacingHorizontalXXL,
    minWidth: 0,
    flexShrink: 0,
    // Sit above the pill fill so Brand-80 circle reads on top of BrandBackground2.
    position: 'relative',
    zIndex: 1,
  },
  expandButton: {
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalXS,
    border: 'none',
    // No vertical padding - keeps the BrandBackground2 pill the same height as the attach circle.
    paddingTop: 0,
    paddingBottom: 0,
    columnGap: 0,
    minHeight: tokens.spacingHorizontalXXL,
    height: tokens.spacingHorizontalXXL,
    // Transparent at rest and on hover so the outer pill is the only brand surface.
    backgroundColor: 'transparent',
    ':hover': {
      backgroundColor: 'transparent',
    },
    ':active': {
      backgroundColor: 'transparent',
    },
    ':hover:active': {
      backgroundColor: 'transparent',
    },
  },
  itemsText: {
    color: tokens.colorNeutralForeground2,
    textAlign: 'left',
  },
  expandIcon: {
    height: tokens.spacingHorizontalL,
    flexShrink: 0,
  },
})

export default useStyles
